// E-Ticaret › İadeler (İade Yönetimi) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.returns';

export const ecommerceReturnsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'İadeler nasıl işlenir?'),
  intro: t(`${G}.intro`, 'Web sitenizden gelen iade taleplerini burada görür, işler veya reddedersiniz. "İşle" düğmesi iade faturası, cari alacak, stok girişi ve gerekirse banka çıkışı kaydı oluşturur; bu yüzden işlemeden önce ürünün size ulaştığından emin olun. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Yenile'),
    stats: t(`${G}.regions.stats`, 'Gider pusulası uyarısı'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    table: t(`${G}.regions.table`, 'İade listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. İade talebini bulun'),
      text: t(`${G}.s1.text`, 'Arama kutusuna iade no, sipariş no, müşteri adı veya iade nedenini yazın. "Durum" ile Talep Edildi, Onaylandı, Teslim Alındı, İncelendi, İade Edildi veya Reddedildi kayıtlarını; "Gider Pusulası" ile Bekliyor / Düzenlendi kayıtlarını süzün.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tutar siparişin para biriminde gösterilir; TL dışıysa altında siparişteki kurla TL karşılığı (≈) yazar.'),
        t(`${G}.s1.tip2`, 'Neden sütununun üzerine gelince müşterinin yazdığı açıklama görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Gerekirse talebi reddedin'),
      text: t(`${G}.s2.text`, 'İşlenmemiş bir talebi reddetmek için satırdaki kırmızı "İade talebini reddet" simgesine basın, Ret Nedeni yazın (zorunlu) ve "Reddet"e basın. Ret nedeni müşteriye gösterilir. Reddedilen iade işlenemez; müşteri gerekirse yeni bir iade talebi açabilir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. İadeyi işleyin'),
      text: t(`${G}.s3.text`, 'Satırdaki "İadeyi işle (ters kayıt + para iadesi)" simgesi "İadeyi İşle" penceresini açar. "İşle"ye basınca İADE faturası kesilir, carinin hesabına alacak yazılır ve satışta stoktan düşülmüşse ürünler stoğa geri alınır. İade kaydı "İade Edildi" olur; tam iadede sipariş de iade edildi olarak işaretlenir.'),
      tips: [
        t(`${G}.s3.tip1`, 'İşlem tekrar çalıştırılırsa yeni kayıt oluşmaz, mevcut kayıt döner. İşlenen satırda bu simge artık görünmez.'),
        t(`${G}.s3.tip2`, 'X al Y öde kampanyalı siparişte kısmi iade kampanya eşiğini bozuyorsa iade tutarı yeniden hesaplanır; müşteri fiilen ödediğinden fazlasını geri almaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Para iade modunu seçin'),
      text: t(`${G}.s4.text`, '"Para İade Modu" paranın müşteriye nasıl döneceğini belirler.'),
      tips: [
        t(`${G}.s4.tip1`, 'Cari bakiyeye alacak (varsayılan): tutar carinin alacağı olarak kalır; para çıkışı yazılmaz.'),
        t(`${G}.s4.tip2`, 'Sağlayıcı üzerinden geri ödeme (banka çıkışı): B2B Ayarları\'ndaki online tahsilat banka hesabından çıkış ve cariye borç kaydı yazılır. Ödeme sağlayıcısı (ör. Moka) panelindeki asıl iadeyi ayrıca elle yapmanız gerekir.'),
        t(`${G}.s4.tip3`, '"Müşteri e-Fatura mükellefi" işaretlenirse sistem İADE faturası, cari alacak ve stok girişi oluşturmaz; iade faturasını müşteri kendisi keser.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s5.title`, '5. Gider pusulasını kaydedin'),
      text: t(`${G}.s5.text`, 'Sistemin İADE faturası kestiği (e-Arşiv / B2C) iadelerde gider pusulası "Bekliyor" olur ve üstte kaç iadenin beklediği uyarısı çıkar. Muhasebe gider pusulasını düzenledikten sonra satırdaki belge simgesiyle Belge No (zorunlu), Belge Tarihi ve isteğe bağlı PDF URL girip "Kaydet"e basın; durum "Düzenlendi" olur.'),
      tips: [
        t(`${G}.s5.tip1`, 'PDF adresi girildiyse satırdaki PDF simgesi belgeyi yeni sekmede açar.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Listede gezinin'),
      text: t(`${G}.s6.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin; sayfa başına 10, 25 veya 50 satır seçebilirsiniz. Başlıktaki yenile simgesi listeyi yeniden yükler, (i) bu rehberi yeniden açar.'),
    },
  ],
});
